export const FetchStatuses = async ({selectedProjectId, accessToken}) => {
    // const apsToken = process.env.REACT_APP_APS_TOKEN;
    // const apsToken = localStorage.getItem('accessToken');
    // console.log('Fetching Statuses projectIdParam:', selectedProjectId);
    // console.log('Fetching Statuses selectedCategoryId', selectedCategoryId);
    const requestHeaders = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    });

    // Create a Request object to inspect headers
    const request = new Request(`https://developer.api.autodesk.com/bim360/assets/v1/projects/${selectedProjectId}/asset-statuses`, {
        method: 'GET',
        headers: requestHeaders
    });

    try {
        const response = await fetch(request);
        // console.log('Response :', response);


        if (!response.ok) {
            throw new Error(`HTTP error from fetching statuses! Status: ${response.status} ${response.statusText}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Error fetching data:', error);
        throw error;
    }
};
